<template src="./carrinho-de-compras.html"></template>
<style lang="less" src="./carrinho-de-compras.less" scoped></style>

<script>
import BtnWhatsapp from '@/components/buttons/btn-whatsapp/btn-whatsapp'
import stringHelper from '@/helpers/string.helper'
import { mapState, mapActions, mapGetters } from 'vuex'

const CarrinhoDeCompras = 'CarrinhoDeCompras'
const PerfilDaLoja = 'PerfilDaLoja'
const mensagemDeInteresseCarrinho = 'Olá, estou interessado nesses produtos:';

    export default {
        components: {
            BtnWhatsapp
        },
        computed: {
                ...mapState(CarrinhoDeCompras, ['produtos']),
                ...mapGetters(CarrinhoDeCompras, ['getQtdProdutosNoCarrinho']),
                ...mapGetters(PerfilDaLoja, ['getNumeroCelularCompleto']),

                possuiProdutosNoCarrinho() { 
                return this.produtos.length > 0 
                }
        },
        methods:{
            ...mapActions(CarrinhoDeCompras, [
                'limparCarrinho',
                'excluirItemCarrinho']),

            getPrevisualizacaoCarrinho(){
                let qtdItens = (this.produtos.length > 1) ? (' mais ' + (this.produtos.length - 1) + ' itens') : '';   
                return this.getUltimoProdutoAdicionadoNoCarrinho() + qtdItens;
            },
            getValorProdutosNoCarrinho(){
                let valorprodutos = 0;
                this.produtos.forEach(x => {
                    valorprodutos += x.precoTotal                        
                });
                return stringHelper.FormatarMoedaPadraoBrasileiro(valorprodutos);
            },
            getUltimoProdutoAdicionadoNoCarrinho(){
                return this.getNomeDoProdutoFormatado(this.produtos[this.produtos.length - 1].nome);
            },
            excluirItem(produtoid){
                this.excluirItemCarrinho({idProduto: produtoid});
            },
            mensagem(){
                let ProdutosNoCarrinho =[]

                this.produtos.forEach(x => {
                    ProdutosNoCarrinho += ` *x${(x.quantidadeTotal)} ${(x.nome)}*\n`
                });
                return  mensagemDeInteresseCarrinho + (ProdutosNoCarrinho)
            },
            getValorFormatado(valorBruto){
                return stringHelper.FormatarMoedaPadraoBrasileiro(valorBruto);
            },
            getNomeDoProdutoFormatado(nomeProduto){
                return stringHelper.FormatarStringCompridaComReticencias(nomeProduto);
            }

        }
    }
</script>